pageId = 'reports-weekly_answers-show'

$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  $('#link-change-date').on 'click', tower.changeReportDate

  url = simple.url()
  return if !url.search.date || !url.search.question
  $(".link-answer[href*=#{url.search.question}][href*=#{url.search.date}]").click()
